<template>
    <div class="w-max">
        <span class="styled-as-h3 mb-5 hidden text-sm lg:block lg:text-xl">
            {{ $snippets['headless.footer.socials'] }}
        </span>
        <nav>
            <ul class="flex items-center">
                <li>
                    <NuxtLink class="group mr-6 block duration-200" target="_blank" :to="siteConfig.facebook">
                        <IconFacebook aria-label="Facebook" class="img-hover-filter size-7 duration-200" />
                    </NuxtLink>
                </li>
                <li>
                    <NuxtLink class="group mr-6 block duration-200" target="_blank" :to="siteConfig.instagram">
                        <IconInstagram aria-label="Instagram" class="img-hover-filter size-7 duration-200" />
                    </NuxtLink>
                </li>
                <li>
                    <NuxtLink class="group block" target="_blank" :to="siteConfig.tiktok">
                        <IconTiktok aria-label="TikTok" class="img-hover-filter size-7 duration-200" />
                    </NuxtLink>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        siteConfig: {
            facebook: string;
            instagram: string;
            tiktok: string;
            [key: string]: any;
        };
    }>();
</script>

<style scoped>
    .group:hover .img-hover-filter {
        filter: invert(89%) sepia(25%) saturate(182%) hue-rotate(15deg) brightness(83%) contrast(83%);
    }
</style>
